/**
 * Parcels Receipt
 */

// React
import React, { useContext, useEffect, useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import {
  getParcelInventoryItemsAction,
  getParcelsWithIdAction,
} from '../parcels/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectParcel,
  makeSelectLoading,
  makeSelectError,
  makeSelectInventoryItemsCount,
} from '../parcels/selectors';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { WrapperReceipt } from './style';
import jMoment from 'moment-jalaali';

// Helper
import { formaterPhoneNumber } from '../../utils/helpers';

// Type
import { SelectorProps, Props } from './interfaces';
import AuthContext from '../../authContext';
import Barcode from 'react-barcode';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(-8),
        },
      },
    },
  })
);

export function Details(props: Props) {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const [parcelItemsPage, setParcelItemsPage] = useState<any>([]);
  const [filtersValues, setFiltersValues] = useState({
    parcelId: { equals: props.match.params.id },
    page: 0,
    size: 10000,
  } as any);

  const setLoopPage = (items: any) => {
    const loopItems = [];
    for (let i = 0; i < Math.ceil(items.length / 13); i++) {
      loopItems.push(i + 1);
    }
    setParcelItemsPage(loopItems);
  };

  useEffect(() => {
    const { id } = props.match.params;
    props.getParcelWithIdActionDispatch(id);
    props.getParcelInventoryItemDispatch({
      ...filtersValues,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.parcel.id && props.inventoryItemsCount) {
      setLoopPage(props.parcel.items);
    }
  }, [props.parcel, props.inventoryItemsCount]);

  useEffect(() => {
    if (parcelItemsPage.length) {
      window.print();
    }
  }, [parcelItemsPage]);
  return (
    <WrapperReceipt className={classes.root}>
      {parcelItemsPage.map((parcelItem: any, itemIndex: number) => {
        return (
          <div className="page">
            <div className=" wrapper ">
              {/*Section 1 */}
              <div
                className="flex"
                style={{
                  marginBottom: '15px',
                }}
              >
                <div className="flex flex-column w-100">
                  <div className="flex justify-content-between align-items-center w-100">
                    <div className="logo-box">
                      <div>
                        <img src="/logo-dark.svg" alt="logo" />
                      </div>
                    </div>
                    <div className="title">
                      {(authContext.user.role === 'WAREHOUSE_OPERATOR' ||
                        authContext.user.role === 'WAREHOUSE_ADMIN'
                        ? 'رسید محموله - '
                        : 'حواله محموله - ') + props?.parcel?.id}
                    </div>
                    <div>
                      <Barcode
                        height={'30px'}
                        fontSize={9}
                        value={props?.parcel?.id}
                      />
                    </div>
                  </div>
                  <div className="flex justify-content-between">
                    <div className="flex">
                      <span className="label"> تاریخ ارسال:</span>
                      <span className="bold">
                        {' '}
                        {props.parcel?.shippingDate &&
                          `${jMoment(props.parcel?.shippingDate, 'YYYY/MM/DD')
                            .locale('fa')
                            .format('jYYYY/jMM/jDD')}`}
                      </span>
                    </div>
                    <div className="flex">
                      <span className="label"> تاریخ تحویل:</span>
                      <span className="bold">
                        {' '}
                        {props.parcel?.deliveryDate &&
                          `${jMoment(props.parcel?.deliveryDate, 'YYYY/MM/DD')
                            .locale('fa')
                            .format('jYYYY/jMM/jDD')}`}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex-1" />
              </div>

              {/* Section 2 */}
              <div className="card-a">
                <div className="card-a_box">
                  <div className="card-a_item">
                    <span className="card-a_label">{'نام مبدا: '}</span>
                    <span className="card-a_text">
                      {' '}
                      {props.parcel?.partnerName}
                    </span>
                  </div>
                  <div className="card-a_item">
                    <span className="card-a_label">{'تلفن مبدا: '}</span>
                    <span className="card-a_text">
                      {formaterPhoneNumber(props.parcel?.agentPhoneNumber)}
                    </span>
                  </div>
                  <div className="card-a_item">
                    <span className="card-a_label">{'صادر کننده: '}</span>
                    <span className="card-a_text">
                      {' '}
                      {props.parcel?.sellerName}{' '}
                    </span>
                  </div>
                  <div className="card-a_item">
                    <span className="card-a_label">{'تعداد کل آیتم ها: '}</span>
                    <span className="card-a_text">
                      {' '}
                      {props.inventoryItemsCount}{' '}
                    </span>
                  </div>
                </div>
              </div>

              {/* Section 3 */}
              <div className="title" style={{ marginTop: '15px' }}>
                محتویات محموله
              </div>

              <div className="card-b">
                <div className="card-b_box">
                  <div className="card-b_header-box">
                    <div className="card-b_header">
                      <div className="card-b_header-item">ردیف</div>
                      <div className="card-b_header-item">نام کالا</div>
                      <div className="card-b_header-item">کد کالا</div>
                      <div className="card-b_header-item">شناسه تنوع کالا</div>
                      <div className="card-b_header-item">تعداد</div>
                      {/* <div className="card-b_header-item">تعدادکارتن</div> */}
                      {/* <div className="card-b_header-item">نوع کارتن</div> */}
                      <div className="card-b_header-item">توضیحات</div>
                    </div>
                  </div>
                  <div className="card-b_content">
                    {props.parcel?.items?.map((item: any, index: number) => {
                      if (
                        (parcelItem - 1) * 13 <= index &&
                        index < parcelItem * 13
                      ) {
                        let variantName = item.productName;
                        for (
                          let i = 0;
                          i <= 2 && item.featureAndValues[i];
                          i++
                        ) {
                          variantName = variantName.concat(
                            ' - ',
                            item.featureAndValues[i].key,
                            ' : ',
                            item.featureAndValues[i].value
                          );
                        }
                        return (
                          <div className="card-b_content-row">
                            <div className="card-b_content-item">
                              {index + 1}
                            </div>
                            <div className="card-b_content-item">
                              {variantName}
                            </div>
                            <div className="card-b_content-item">
                              {item.productCode}
                            </div>
                            <div className="card-b_content-item">
                              {item.skuId}
                            </div>
                            <div className="card-b_content-item">
                              {item.count}
                            </div>
                            <div className="card-b_content-item">{ }</div>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>

              {/* Section 4 */}
              <div className="title" style={{ marginTop: '15px' }}>
                توضیحات
              </div>

              <div className="description" />

              {/* Section Last */}
              <div className="sing-box">
                <div className="item">
                  <span>امضا تحویل دهنده</span>
                  <span>:تاریخ</span>
                </div>
                <div className="item">
                  <span>امضا راننده</span>
                  <span>:تاریخ</span>
                </div>
                <div className="item">
                  <span>امضا تحویل گیرنده</span>
                  <span>:تاریخ</span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </WrapperReceipt>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  inventoryItemsCount: makeSelectInventoryItemsCount(),
  parcel: makeSelectParcel(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getParcelWithIdActionDispatch: (id: number) =>
      dispatch(getParcelsWithIdAction({ id })),
    getParcelInventoryItemDispatch: (payload: object) =>
      dispatch(getParcelInventoryItemsAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
